<template>
  <div class="modal-cross-domain-setting">
    <img class="close-img" src="/../img/ic-m-close.svg" @click="onClick" />
    <div class="slot1">
      <span>{{ $t("cross_domain_settings.title") }}</span>
      <div class="date_guide">
        <span v-if="updateDate"
          >{{ $t("cross_domain_settings.updated") }} {{ updateDate }}</span
        >
        <div class="guide">
          <a href="http://imqa.io/documents" target="_blank">
            <img src="/../img/icon-guide-pg.svg" />
            <span>{{ $t("cross_domain_settings.guide") }}</span>
          </a>
        </div>
      </div>
    </div>
    <span class="seperate-line"></span>
    <div class="slot2">
      <p>{{ $t("cross_domain_settings.sub_title") }}</p>
      <!-- <p>
        IMQA에서 분석할 메인 도메인 외에 교차 도메인을 설정할 수 있습니다.<br/>
        <span class="color_blue">서브 도메인</span>(예: m.imqa.io) 별도 구성되어 있을 경우나 <span class="color_blue">CORS (교차 출처 리소스 공유)</span> 접근이 필요한 경우 허용할 출처를 지정할 수 있습니다.
      </p> -->
    </div>
    <div class="slot3">
      <div class="domain_tooltip">
        <span>{{
          $t("cross_domain_settings.allowed_origins_tooltip.title")
        }}</span>
        <span class="title_question">
          <div class="tooltiptext">
            <span>allowed_origins</span>
            <ul>
              <li>
                {{ $t("cross_domain_settings.allowed_origins_tooltip.text1") }}
              </li>
              <li>
                {{ $t("cross_domain_settings.allowed_origins_tooltip.text2") }}
              </li>
              <li>
                {{ $t("cross_domain_settings.allowed_origins_tooltip.text3") }}
              </li>
              <!-- <li>접근을 어용할 도메인 목록을 지정합니다. (예: http://localhost:8080)</li>
              <li>1줄로 구분하여 입력할 수 있습니다.</li>
              <li>프로토콜 및 포트번호, 대소문자를 구분하여 * 문자를 포함할 수 없습니다.</li> -->
            </ul>
          </div>
        </span>
      </div>
      <div class="domains">
        <span class="color_blue">{{ mainDomain }}</span>
        <textarea
          class="domain_textarea"
          v-model="domainList.stringVer"
        ></textarea>
      </div>
    </div>
    <div class="slot4">
      <button class="submit-btn" type="button" @click="onSave">
        {{ $t("common.save") }}
      </button>
      <button class="cancel-btn" type="button" @click="onClick">
        {{ $t("common.cancel") }}
      </button>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "modal-cross-domain-setting",
  components: {},
  data() {
    return {
      mainDomain: "",
      projectId: 0,
      domainList: {
        stringVer: "",
        arrayVer: [],
      },
      updateDate: null,
      expUrl: /^(http|https):\/\/(([\w\-]+(\.[\w\-]+)+)|localhost)(:\d+)?/i,
    };
  },
  computed: {},
  created() {
    this.mainDomain = this.$store.state.modalProps.pName;
    this.projectId = this.$store.state.modalProps.pId;

    this.getProjectAllowOrigins(this.projectId);
  },
  methods: {
    onClick() {
      this.$emit("closeEvent", true);
    },
    formatDate(date) {
      const dateObj = new Date(date);
      dateObj.setHours(dateObj.getHours() + this.$store.state.timezone);

      const year = dateObj.getFullYear();
      const month =
        dateObj.getMonth() >= 10
          ? dateObj.getMonth() + 1
          : "0" + (dateObj.getMonth() + 1);
      const day =
        dateObj.getDate() >= 10 ? dateObj.getDate() : "0" + dateObj.getDate();
      const hour =
        dateObj.getHours() >= 10
          ? dateObj.getHours()
          : "0" + dateObj.getHours();
      const min =
        dateObj.getMinutes() >= 10
          ? dateObj.getMinutes()
          : "0" + dateObj.getMinutes();

      return `${year}-${month}-${day} ${hour}:${min}`;
    },
    getProjectAllowOrigins(id) {
      axios.get(`/api/project/${id}/allowed_origin`).then((res) => {
        if (res.data.data.length > 0) {
          this.updateDate = this.formatDate(res.data.data[0].update_time);
          this.domainList.arrayVer = JSON.parse(
            res.data.data[0].allowed_origins
          ).filter((domain) => domain != this.mainDomain);
          this.domainList.stringVer = this.convertToString(
            this.domainList.arrayVer
          );
        }
      });
    },
    convertToString(domainList) {
      let domainString = "";
      domainList.forEach((domain) => {
        domainString += domain + "\n";
      });
      return domainString;
    },
    convertToArray(domainString) {
      let domainArray = [];
      domainArray = domainString
        .split("\n")
        .map((domain) => domain.trim())
        .filter((domain) => domain != "");
      domainArray = domainArray
        .toString()
        .trim()
        .split(",")
        .filter((domain) => domain != "");

      return domainArray;
    },
    domainValidation() {
      let isValid = true;
      this.domainList.arrayVer.some((domain) => {
        if (!this.checkUrl(domain)) {
          alert(this.$t("cross_domain_settings.alert_url_fail"));
          isValid = false;
          return true;
        }
      });

      return isValid;
    },
    checkUrl(strUrl) {
      const result = this.expUrl.test(strUrl);
      return result;
    },
    onSave() {
      this.domainList.arrayVer = this.convertToArray(this.domainList.stringVer);

      if (!this.domainValidation()) return;

      this.domainList.arrayVer.push(this.mainDomain);
      const param = {
        allowed_origins: this.domainList.arrayVer,
      };

      axios
        .post(`/api/project/${this.projectId}/allowed_origin`, { ...param })
        .then((res) => {
          alert(this.$t("cross_domain_settings.alert_complete"));
          this.$emit("closeEvent");
        })
        .catch(() => {
          alert(this.$t("cross_domain_settings.alert_fail"));
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-cross-domain-setting {
  margin: auto;
  border-radius: 8px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.54);
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  z-index: 4;
  box-sizing: border-box;
  width: 687px;
  padding: 11.5px 24px 33px 24px;
  .slot1 {
    width: 100%;
    display: flex;
    justify-content: space-between;
    & > span {
      font-size: 15px;
      color: #2e2e2e;
      font-weight: 700;
    }
    .date_guide {
      display: flex;
      & > span {
        font-size: 12px;
        color: #847f7c;
        margin-right: 11px;
      }
      .guide {
        a {
          display: flex;
          align-items: center;
          box-sizing: border-box;
          text-decoration: none;
          color: #565555;
          img {
            margin-right: 11px;
            margin-top: 3px;
          }
          span {
            font-size: 12px;
          }
        }
      }
    }
  }
  .slot2 {
    width: 100%;
    padding-top: 14px;
    & > p {
      font-size: 13px;
      color: #848484;
    }
  }
  .slot3 {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding-top: 15px;
    .domain_tooltip {
      .title_question {
        display: inline-block;
        position: relative;
        top: -1px;
        width: 14px;
        height: 14px;
        margin-left: 3px;
        vertical-align: middle;
        background: url(@/assets/img/ico-question.svg) no-repeat;
      }
      .title_question:hover {
        cursor: pointer;
      }
      .title_question:hover .tooltiptext {
        visibility: visible;
      }
      .title_question .tooltiptext {
        position: absolute;
        background: #000000;
        top: 25px;
        left: -6px;
        visibility: hidden;
        width: max-content;
        padding: 9px;
        z-index: 2;
        word-wrap: break-word;
        opacity: 0.8;
        border-radius: 2px;
        font-size: 11px;
        color: #ffffff;
      }
      & > span {
        font-size: 13px;
        color: #626262;
      }
    }
    .domains {
      background-color: #f6f7fa;
      width: 508px;
      height: 410px;
      padding-top: 14px;
      padding-left: 21px;
      overflow-y: scroll;
      span {
        font-size: 13px;
        display: block;
        line-height: 24px;
      }
      input {
        width: calc(100% - 10px);
        border: none;
        border-left: 1px solid #4639de;
        background-color: inherit;
        &:focus {
          border: none;
        }
      }
      .domain_textarea {
        width: 484px;
        height: 369px;
        background-color: inherit;
        border: none;
        resize: none;
        font-family: inherit;
        padding: 0;
        line-height: 24px;
        &:focus-visible {
          outline: none;
        }
      }
    }
  }
  .slot4 {
    width: 100%;
    display: flex;
    justify-content: center;
    padding-top: 23px;
  }
}
.seperate-line {
  width: 100%;
  height: 1px;
  border: solid 0.5px #e2e2e2;
  margin-top: 8px;
  box-sizing: border-box;
}
@mixin btn-text {
  font-size: 14px;
  font-weight: bold;
  color: #ffffff;
  outline: none;
  border: none;
}
.submit-btn {
  @include btn-text;
  float: left;
  margin-right: 11px;
  width: 120px;
  height: 35px;
  border: 1px solid #4639de;
  background-color: #ffffff;
  color: #4639de;
  cursor: pointer;
}
.cancel-btn {
  @include btn-text;
  width: 120px;
  height: 35px;
  border: 1px solid #bebebe;
  background-color: #ffffff;
  color: #bebebe;
  cursor: pointer;
}
.close-img {
  position: absolute;
  top: 0px;
  cursor: pointer;
  left: 697px;
}
.color_blue {
  color: #4639de;
}
.guide {
  a {
    box-sizing: border-box;
    text-decoration: none;
    color: #565555;
    span {
      font-size: 12px;
    }
  }
}
</style>
